import { useEffect, useState, memo } from 'react';
import cls from 'classnames';

import getBreadcrumbSublinks from '../../../utils/breadcrumbSubLinks';

import useStyles from './styles';
import Breadcrumb from './Breadcrumb';
import { IBreadcrumb, IWithLocationBreadcrumb } from './types';

const homeItem: IBreadcrumb = {
  text: 'Home',
  href: '/',
};

function WithBreadcrumb({
  items,
  whiteText = false,
  withLayoutBackground = true,
  className,
}: IWithLocationBreadcrumb) {
  const classes = useStyles({ whiteText, withLayoutBackground });
  const [itemsToDysplay, setItemsToDisplay] = useState<IBreadcrumb[]>([]);
  const windowObj = typeof window === 'undefined' ? null : window;
  useEffect(() => {
    if (!items) {
      if (windowObj?.location.pathname) {
        const paths = getBreadcrumbSublinks(windowObj.location.pathname);
        const links = paths.map((path) => {
          return {
            href: `${window.location.origin}${path.href}`,
            text: path.text,
          };
        });
        setItemsToDisplay([homeItem, ...links]);
      }
    } else {
      const links = items.map((path) => {
        return {
          href: `${window.location.origin}${path.href}`,
          text: path.text,
        };
      });
      setItemsToDisplay([homeItem, ...links]);
    }
  }, [items, windowObj?.location?.pathname]);

  return (
    <div className={cls(classes.root, className)}>
      {itemsToDysplay.length > 1 && (
        <div className={classes.container}>
          <Breadcrumb items={itemsToDysplay} whiteText={whiteText} />
        </div>
      )}
    </div>
  );
}

export default memo(WithBreadcrumb);
